const defaultGroupsForm = {
    id: '',
    name: '',
}

export default defaultGroupsForm;